(() => {
	const parser = new DOMParser();
	const formatCurrency = new Intl.NumberFormat('en-US', {
		style: 'currency',
		currency: 'USD'
	});

	const $nav = $('.aside-nav');
	const $cart = $('[data-drawer="cart-drawer"]');
	const $content = $cart.find('.drawer__content');
	const $toggle = $('[data-toggle-drawer="cart-drawer"]');
	const $qty = $('#cart-quantity');

	let isCartOpen = false;

	function init() {
		initAddToCart();
		initCartToggles();
		initCartOptions();
		updateCartQty();
	}

	// Cart Drawer Functions
	// ----------------------------------------

	async function loadCartContent(type, params = null) {
		const cart = getCart();
		let url = ROOT + '/cart';

		if (!type || (type === 'cart' && !cart.items.length)) {
			url += `?empty=true`;
			type = 'empty';
		} else {
			url += `?${type}=true`;
		}

		if (params) {
			url += `&${params}`;
		}

		if ($content.not(':empty')) {
			await gsap.to($content, {
				duration: 0.5,
				ease: 'power2.inOut',
				opacity: 0,
				x: 25
			});
		}

		$cart.addClass('-loading');

		gsap.set($content, {
			opacity: 0,
			x: 25
		});

		const data = await ajax('GET', url);
		const newDoc = parser.parseFromString(data, 'text/html');
		const newContent = newDoc.querySelector('#cart-content');

		$content.html(newContent.innerHTML);

		if (type === 'cart') {
			const $items = $content.find('#cart-items');
			const $placeOrder = $content.find('#place-order');

			updateCartTotal(false);

			// Append cart item html
			cart.items.forEach((item) => {
				let line = `<article id="cart-item-${item.id}" class="cart-item mb-4" data-id="${item.id}">`;

				// only add img tag if src contains image extension
				if (item.thumbnail.match(/[^/]+(jpg|png|gif)$/)) {
					line += `<img class="cart-item__img" src="${item.thumbnail}" />`;
				}

				line += `<div class="cart-item__details">
							<a href="${item.url}" class="h4 text-primary">
								${item.name}
							</a>
							<p class="text-sm">
								${item.grade}
							</p>
						</div>
						<footer class="cart-item__footer">
							<div class="cart-item__controls">
								<button type="button" class="cart-item__control js-decrease-qty">
									<span>-</span>
								</button>
								<div class="cart-item__qty js-qty">
									${item.quantity}
								</div>
								<button type="button" class="cart-item__control js-increase-qty">
									<span>+</span>
								</button>
							</div>
							<span class="cart-item__price js-price" data-amount="${item.price * item.quantity}">
								${formatCurrency.format(item.price * item.quantity)}
							</span>
						</footer>
					</article>
				`;

				$items.append(line);
			});

			// Add bindings to cart items
			$items.find('.cart-item').each(function () {
				initCartItem(cart, this);
			});

			// Init button
			$placeOrder.on('click', placeOrder);
		}

		$cart.removeClass('-loading');

		await gsap.to($content, {
			duration: 0.5,
			ease: 'power2.inOut',
			opacity: 1,
			x: 0
		});

		initCartToggles();
		initCartOptions();
		initPageLinks();
		initForms();

		const $login = $content.find('form[name="login-form"]');

		if ($login.length) {
			$login.on('form:success', () => {
				loadCartContent('cart');
			});
		}

		const $register = $content.find('form[name="register-form"]');

		if ($register.length) {
			$register.on('form:success', () => {
				loadCartContent('cart');
			});
		}
	}

	function clearCartContent() {
		$content.html('');
	}

	function initCartToggles() {
		const $toggles = $('[data-load-cart]');

		$toggles.click(function (e) {
			e.preventDefault();

			loadCartContent(this.dataset.loadCart);
		});
	}

	function initCartItem(cart, item) {
		const $item = $(item);
		const $increase = $item.find('.js-increase-qty');
		const $decrease = $item.find('.js-decrease-qty');
		const $qty = $item.find('.js-qty');
		const $price = $item.find('.js-price');

		const cartItem = cart.items.find((c) => c.id === parseInt(item.dataset.id));

		$increase.on('click', () => {
			cartItem.quantity++;

			// Update cart
			setCart(cart);

			// Update html
			$qty.html(cartItem.quantity);

			// Get new values
			let from = parseInt($price.data('amount'));
			let to = cartItem.price * cartItem.quantity;

			// Trigger updates
			animatePrice(from, to);
			updateCartTotal();
			updateCartQty();
		});

		$decrease.on('click', async () => {
			cartItem.quantity--;

			// Update html
			$qty.html(cartItem.quantity);

			// Remove from cart if no qty
			if (cartItem.quantity <= 0) {
				cart.items = cart.items.filter((i) => i.id !== cartItem.id);

				if (!cart.items.length) {
					await loadCartContent('empty');
				} else {
					await gsap
						.timeline()
						.to($item, {
							duration: 0.3,
							opacity: 0,
							x: 25
						})
						.set($item, {
							overflow: 'hidden'
						})
						.to($item, {
							duration: 0.3,
							height: 0
						});

					$item.remove();
				}
			} else {
				let from = parseInt($price.data('amount'));
				let to = cartItem.price * cartItem.quantity;

				animatePrice(from, to);
			}

			// Trigger updates
			setCart(cart);
			updateCartTotal();
			updateCartQty();
		});

		function animatePrice(from, to, animate = true) {
			let amount = {var: from};

			if (animate) {
				gsap.to(amount, {
					duration: 0.5,
					var: to,
					onUpdate: () => {
						$price.html(formatCurrency.format(amount.var));
						$price.data('amount', amount.var);
					},
					ease: Linear.easeNone
				});
			} else {
				$price.html(formatCurrency.format(to));
				$price.data('amount', to);
			}
		}
	}

	function initAddToCart() {
		const btn = document.querySelector('#add-to-cart');
		const gradeSelect = document.querySelector('#grade-select');

		if (!btn || !gradeSelect) return;

		const confirm = btn.querySelector('#confirm');
		const increaseQty = btn.querySelector('#increase-qty');
		const decreaseQty = btn.querySelector('#decrease-qty');
		let qty = parseInt(btn.dataset.quantity);

		gradeSelect.addEventListener('change', () => {
			const option = gradeSelect.options[gradeSelect.selectedIndex];

			btn.dataset.id = gradeSelect.value;
			btn.dataset.grade = option.dataset.name;
			btn.dataset.price = option.dataset.price;

			confirm.removeAttribute('disabled');
			increaseQty.removeAttribute('disabled');
			decreaseQty.removeAttribute('disabled');
		});

		confirm.addEventListener('click', () => {
			if (btn.classList.contains('-loading')) return;

			btn.classList.add('-loading');

			const cart = getCart();
			const id = parseInt(btn.dataset.id);
			const quantity = parseInt(btn.dataset.quantity);
			const item = cart.items.find((i) => i.id === id);

			if (item) {
				item.quantity += quantity;
			} else {
				cart.items.push({
					id: id,
					name: btn.dataset.name,
					grade: btn.dataset.grade,
					price: parseFloat(btn.dataset.price),
					quantity: quantity,
					thumbnail: btn.dataset.thumbnail,
					url: btn.dataset.url
				});
			}

			setCart(cart);

			if (isCartOpen) {
				loadCartContent('cart');
			}

			setTimeout(() => {
				btn.classList.remove('-loading');
				btn.classList.add('-done');

				updateCartQty();

				setTimeout(() => {
					btn.classList.remove('-done');
				}, 1000);
			}, 1000);
		});

		increaseQty.addEventListener('click', () => {
			if (btn.classList.contains('-loading')) return;

			qty++;
			btn.dataset.quantity = qty;
			confirm.value = `Add ${qty} To Cart`;
		});

		decreaseQty.addEventListener('click', () => {
			if (btn.classList.contains('-loading')) return;
			if (qty <= 1) return;

			qty--;
			btn.dataset.quantity = qty;
			confirm.value = `Add ${qty} To Cart`;
		});
	}

	function initCartOptions() {
		const $inputGift = $('#input-gift');
		const $inputDelivery = $('input[name="delivery"]');

		$inputGift.on('change', () => {
			const isGift = $inputGift[0].checked;
			const isPickup = $('input[name="delivery"]:checked').val() === 'pickup';

			toggleCartOptions(isGift, isPickup);
		});

		$inputDelivery.on('change', () => {
			const isGift = $inputGift[0].checked;
			const isPickup = $('input[name="delivery"]:checked').val() === 'pickup';

			toggleCartOptions(isGift, isPickup);
		});
	}

	function toggleCartOptions(isGift, isPickup) {
		const $giftWrapping = $('#gift-wrapping');

		const $giftRecipient = $('#gift-recipient');
		const $giftRecipientInput = $('#input-gift-recipient');

		const $giftAddress = $('#gift-address');
		const $giftAddressInput = $('#input-gift-address');

		const $giftPhone = $('#gift-phone');
		const $giftPhoneInput = $('#input-gift-phone');

		const $giftMessage = $('#gift-message');
		const $giftMessageInput = $('#input-gift-message');

		if (isGift) {
			$giftWrapping.removeClass('d-none');

			$giftRecipient.removeClass('d-none');
			$giftRecipientInput.attr('required', true);

			$giftAddress.removeClass('d-none');
			$giftAddressInput.attr('required', true);

			$giftPhone.removeClass('d-none');
			$giftPhoneInput.attr('required', true);

			$giftMessage.removeClass('d-none');
			$giftMessageInput.attr('required', true);
		} else {
			$giftWrapping.addClass('d-none');

			$giftRecipient.addClass('d-none');
			$giftRecipient.find('.error').remove();
			$giftRecipientInput.removeAttr('required').val('').removeClass('-error');

			$giftAddress.addClass('d-none');
			$giftAddress.find('.error').remove();
			$giftAddressInput.removeAttr('required').val('').removeClass('-error');

			$giftPhone.addClass('d-none');
			$giftPhone.find('.error').remove();
			$giftPhoneInput.removeAttr('required').val('').removeClass('-error');

			$giftMessage.addClass('d-none');
			$giftMessage.find('.error').remove();
			$giftMessageInput.removeAttr('required').val('').removeClass('-error');
		}
	}

	// Cart Functions
	// ----------------------------------------

	function getCart() {
		let cart = localStorage.getItem('cart');

		if (cart) {
			// console.log('Local cart found.');
			return JSON.parse(cart);
		} else {
			// console.log('No cart found, creating empty cart.');

			cart = {
				items: []
			};

			setCart(cart);

			return cart;
		}
	}

	function setCart(cart) {
		localStorage.setItem('cart', JSON.stringify(cart));
	}

	function clearCart() {
		localStorage.removeItem('cart');
	}

	async function updateCartTotal(animate = true) {
		const cart = getCart();
		const total = document.querySelector('#cart-total');

		if (!total) return;

		let amount = {var: parseInt(total.dataset.amount)};
		let newAmount = 0;

		cart.items.forEach((item) => {
			newAmount += item.price * item.quantity;
		});

		if (animate) {
			await gsap.to(amount, {
				duration: 0.5,
				var: newAmount,
				onUpdate: () => {
					total.innerHTML = formatCurrency.format(amount.var);
					total.dataset.amount = amount.var;
				},
				ease: Linear.easeNone
			});
		} else {
			total.innerHTML = formatCurrency.format(newAmount);
			total.dataset.amount = newAmount;
		}
	}

	function updateCartQty() {
		const cart = getCart();
		let qty = 0;

		cart.items.forEach((item) => (qty += item.quantity));

		$qty.html(qty);

		if (qty <= 0) {
			$nav.removeClass('-offset-right');
			$toggle.addClass('-no-items');
		} else {
			$nav.addClass('-offset-right');
			$toggle.removeClass('-no-items');
		}
	}

	async function placeOrder() {
		const cart = getCart();

		const orderLines = [];
		let orderTotal = 0;

		if (!cart.items || !cart.items.length) {
			console.error('No items in cart, aborting.');
			return;
		}

		$cart.find('#place-order').addClass('-loading').attr('disabled', true);

		const isValid = validate();

		if (!isValid) {
			$cart.find('#place-order').removeClass('-loading').removeAttr('disabled');
			return;
		}

		cart.items.forEach((item) => (orderTotal += item.price * item.quantity));

		const {id} = JSON.parse(await ajax('GET', `${ROOT}api/get-customer/`));

		if (!id) {
			console.log('User is not logged in.');
			return;
		}

		// Create order lines
		await asyncForEach(cart.items, async (item) => {
			const data = new FormData();

			data.append('fields[stock][entries]', [item.id]);
			data.append('fields[quantity]', item.quantity);
			data.append('fields[price]', item.price);
			data.append('action[create-order-line]', 1);

			const res = await ajax('POST', `${ROOT}api/create-order-line/`, data);
			const resData = JSON.parse(res);

			if (resData.id) {
				orderLines.push(resData.id);
			} else {
				console.log(resData);
			}
		});

		// Create order
		const data = new FormData();
		const timestamp = Date.now().toString().slice(-4) + Math.floor(Math.random() * Math.floor(99));
		const $giftInput = $('#input-gift');
		const $giftWrappingInput = $('#input-gift-wrapping');
		const $giftRecipientInput = $('#input-gift-recipient');
		const $giftAddressInput = $('#input-gift-address');
		const $giftPhoneInput = $('#input-gift-phone');
		const $giftMessageInput = $('#input-gift-message');

		data.append('fields[order-number]', 'web-' + timestamp);
		data.append('fields[customer][entries]', [id]);
		data.append('fields[order-lines][entries]', orderLines);
		data.append('fields[order-status]', 'Pending');
		data.append('fields[shipping-cost]', 0);
		data.append('fields[shipping-type][entries]', []);
		data.append('fields[total-cost]', orderTotal);

		if ($giftInput.is(':checked')) {
			data.append('fields[gift]', 'yes');

			if ($giftWrappingInput.val()) {
				data.append('fields[gift-options]', $giftWrappingInput.val());
			}

			if ($giftRecipientInput.val()) {
				data.append('fields[gift-recipient]', $giftRecipientInput.val());
			}

			if ($giftAddressInput.val()) {
				data.append('fields[gift-recipient-address]', $giftAddressInput.val());
			}

			if ($giftPhoneInput.val()) {
				data.append('fields[gift-recipient-phone]', $giftPhoneInput.val());
			}

			if ($giftMessageInput.val()) {
				data.append('fields[gift-message]', $giftMessageInput.val());
			}
		}

		// Add the delivery method
		if ($('input[name="delivery"]:checked').val() === 'pickup') {
			data.append('fields[delivery-type]', 'Pick Up');
		} else {
			data.append('fields[delivery-type]', 'Delivery');
		}

		data.append('action[create-order]', 1);

		const res = await ajax('POST', `${ROOT}api/create-order/`, data);
		const resData = JSON.parse(res);

		$cart.find('#place-order').removeClass('-loading');

		if (resData.result === 'success') {
			await loadCartContent('order-confirmation', `order-id=${timestamp}`);
			clearCart();
		} else {
			console.error('something went wrong');
			console.log(resData);
		}
	}

	function validate() {
		const $giftInput = $('#input-gift');

		const $giftRecipient = $('#gift-recipient');
		const $giftRecipientInput = $('#input-gift-recipient');

		const $giftAddress = $('#gift-address');
		const $giftAddressInput = $('#input-gift-address');

		const $giftPhone = $('#gift-phone');
		const $giftPhoneInput = $('#input-gift-phone');

		const $giftMessage = $('#gift-message');
		const $giftMessageInput = $('#input-gift-message');

		if ($giftInput.is(':checked')) {
			if (!$giftRecipientInput.val()) {
				$giftRecipient.find('.error').remove();
				$giftRecipient.append('<p class="form-group__help error">Please enter the recipient\'s name.</p>');
				$giftRecipientInput.addClass('-error');
				return false;
			} else {
				$giftRecipient.find('.error').remove();
				$giftRecipientInput.removeClass('-error');
			}

			if (!$giftAddressInput.val()) {
				$giftAddress.find('.error').remove();
				$giftAddress.append('<p class="form-group__help error">Please enter the recipient\'s address.</p>');
				$giftAddressInput.addClass('-error');
				return false;
			} else {
				$giftAddress.find('.error').remove();
				$giftAddressInput.removeClass('-error');
			}

			if (!$giftPhoneInput.val()) {
				$giftPhone.find('.error').remove();
				$giftPhone.append('<p class="form-group__help error">Please enter the recipient\'s phone number.</p>');
				$giftPhoneInput.addClass('-error');
				return false;
			} else {
				$giftPhone.find('.error').remove();
				$giftPhoneInput.removeClass('-error');
			}

			if (!$giftMessageInput.val()) {
				$giftMessage.find('.error').remove();
				$giftMessage.append('<p class="form-group__help error">Please enter a message to the recipient.</p>');
				$giftMessageInput.addClass('-error');
				return false;
			} else {
				$giftMessage.find('.error').remove();
				$giftMessageInput.removeClass('-error');
			}
		}

		return true;
	}

	// Events
	// ----------------------------------------

	$cart.on('drawer:will-open', () => {
		gsap.to('#cart-toggle', {
			duration: 0.5,
			ease: 'power2.inOut',
			right: $cart.outerWidth() + 15
		});

		loadCartContent('cart');
	});

	$cart.on('drawer:did-open', () => {
		isCartOpen = true;
		$nav.addClass('-cart-open');
		$toggle.addClass('-cart-open');
	});

	$cart.on('drawer:will-close', () => {
		gsap.to('#cart-toggle', {
			duration: 0.5,
			ease: 'power2.inOut',
			right: 15,
			clearProps: true
		});
	});

	$cart.on('drawer:did-close', () => {
		isCartOpen = false;
		$nav.removeClass('-cart-open');
		$toggle.removeClass('-cart-open');
		clearCartContent();
	});

	$DOC.ready((e) => {
		init();
	});

	$WINDOW.on('page:content-updated', () => {
		init();
	});
})();

